import LayoutLogin from "../../layout/components/LayoutLogin";
import Login from "../../auth/pages/LoginPage";
import RegisterPage from "../../auth/pages/RegisterPage";

export const RoutesPublics = [

  /* ======== PUBLICAS ======== */

  // {
  //   path: "/",
  //   exact: true,
  //   label: 'Home',
  //   main: () => <LayoutManager children={ Home } pageName={'HomePageAuth'} hideTheFooter={true}/>
  // },
  {
    path: "/",
    exact: true,
    main: () => <LayoutLogin children={ Login } pageName={'Login'}/>
  },
  {
    path: "/login",
    exact: true,
    main: () => <LayoutLogin children={ Login } pageName={'Login'}/>
  },
  // {
  //   path: "/register",
  //   exact: true,
  //   main: () => <LayoutLogin children={ RegisterPage } pageName={'Register'}/>
  // },
];
